/**
 * Copied warning icon with error tooltip for RMA list rows (no import from rma-list-page).
 */
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../../components/fonts/font-props";
import IconWarning from "../../../../../../components/icons/icon-warning/icon-warning";
import { TOOLTIP_VARIANTS, Tooltip } from "../../../../../../components/tooltip/tooltip";
import { TOOLTIP_PLACEMENTS } from "../../../../../../components/tooltip/tooltip-box";
import "./rma-list-row-require-attention-icon.scss";

interface IRmaListRowRequireAttentionIconProps {
    errorText: string;
}

const RmaListRowRequireAttentionIcon: React.FC<IRmaListRowRequireAttentionIconProps> = ({ errorText }) => {
    return (
        <div className="rma-list-row-require-attention-icon">
            <Tooltip
                content={
                    <div className="rma-list-row-require-attention-icon__tooltip">
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>{errorText}</FontBody2>
                    </div>
                }
                variant={TOOLTIP_VARIANTS.ERROR}
                placement={TOOLTIP_PLACEMENTS.RIGHT}
            >
                <IconWarning color="var(--color-accent-3)" />
            </Tooltip>
        </div>
    );
};

export default RmaListRowRequireAttentionIcon;
